import React from 'react';
import colors from '../../utils/colors';

const SongCellLoading = () => {
  return (
    <div className="flex items-center justify-between px-4 py-3">
      <div className="flex gap-4 items-center">
        {/* Thumbnail Shimmer */}
        <div
          className="w-[67px] h-[86px] rounded-xl flex-shrink-0 shimmer-loading relative overflow-hidden"
          style={{ backgroundColor: colors.bg.fog.thin }}
        />

        {/* Text Content Shimmer */}
        <div className="flex flex-col gap-2">
          {/* Title shimmer */}
          <div
            className="h-2 w-[104px] rounded-full shimmer-loading relative overflow-hidden"
            style={{ backgroundColor: colors.bg.fog.thin }}
          />
          {/* Subtitle shimmer */}
          <div
            className="h-2 w-[200px] rounded-full shimmer-loading relative overflow-hidden"
            style={{ backgroundColor: colors.bg.fog.thin }}
          />
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        .shimmer-loading::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            rgba(253, 66, 156, 0) 0%,
            rgba(253, 66, 156, 0.15) 50%,
            rgba(253, 66, 156, 0) 100%
          );
          animation: shimmer 1.5s infinite;
        }
      `}</style>
    </div>
  );
};

export default SongCellLoading;
